<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="mystery-box-content"
    [viewName]="title"
    [record]="mysteryBoxContentRecord"
    [fields]="fields"
    [showLocalizedValuesButton]="true"
>
</dynamic-view-v2>

